import { render } from "./ApiAnd3PIntegrations.vue?vue&type=template&id=4c85f41b&scoped=true"
import script from "./ApiAnd3PIntegrations.vue?vue&type=script&lang=js"
export * from "./ApiAnd3PIntegrations.vue?vue&type=script&lang=js"

import "./ApiAnd3PIntegrations.vue?vue&type=style&index=0&id=4c85f41b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c85f41b"]])

export default __exports__